/******/window.PXUTheme.jsSearch={init:function(e){
// Add settings from schema to current object
window.PXUTheme.jsSearch=$.extend(this,window.PXUTheme.getSectionData(e)),
// If breadcrumbs enabled and basic pagination is set, call breadcrumbs object
this.enable_breadcrumb&&"basic_pagination"==this.pagination_type&&window.PXUTheme.breadcrumbs.init(this.number_of_pages)},unload:function(e){window.PXUTheme.breadcrumbs.unload()}}
/******/;